module.exports = __webpack_public_path__ + "static/img/jjfa_01.fb2751b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jjfa_01.jpg
// module id = yqus
// module chunks = 1